var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "travel-gallery" }, [
    _c("div", { staticClass: "image-gallery" }, [
      _c(
        "div",
        { staticClass: "row" },
        _vm._l(_vm.elements, function (e, key) {
          return _c(
            "div",
            { class: _vm.getImageGridClass(key) },
            [
              e.url
                ? _c("lazy-youtube", {
                    staticClass: "travel-gallery-video",
                    attrs: {
                      src: _vm._f("cleanVideoUrl")(e.url),
                      "custom-thumbnail": e.vorschaubild
                        ? _vm.getLargestAvailableImage(e.vorschaubild.filenames)
                        : "",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              e.filenames && _vm.getLargestAvailableImage(e.filenames)
                ? _c(
                    "a",
                    {
                      staticClass: "travel-gallery-image img-link",
                      attrs: {
                        "data-fancybox": _vm.fancyboxGroup,
                        "data-caption": _vm.mergeImageInfo(e),
                        href: e.filenames.zoomed
                          ? e.filenames.zoomed
                          : _vm.getLargestAvailableImage(e.filenames),
                        title: _vm.mergeImageInfo(e),
                      },
                    },
                    [
                      _c("responsive-image", {
                        attrs: {
                          alt: e.legende,
                          title: _vm.mergeImageInfo(e),
                          src: e.filenames.jpg_fallback_3x2,
                          "src-xs": e.filenames.img800_3x2,
                          "src-sm": e.filenames.img400_3x2,
                          "src-md": e.filenames.img400_3x2,
                          "src-lg": e.filenames.img800_3x2,
                          "fixed-aspect-ratio": 3 / 2,
                          "img-class": "travel-detail-picture img-responsive",
                        },
                      }),
                      _vm._v(" "),
                      key == 4 && _vm.extraImageCount > 0
                        ? _c(
                            "span",
                            { staticClass: "travel-gallery-image-count" },
                            [
                              _vm._v(
                                "+ " + _vm._s(_vm.extraImageCount) + " Fotos"
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }